import React, {Component} from 'react'
import { Table } from 'antd'
import "./style.less"
import { getConsumeRecord } from "@/api/agent"
import { timestamp2DateStr } from "@/utils/format"

class CustomerList extends Component {
    constructor(pros) {
        super(pros);
        // TODO: 表格的宽度属性width不知道为什么不生效，站点id比较多时，展现不美观
        this.state = {
            loading: true,

            // 分页
            current: 1,
            pageSize: 8,
            offset: 0,

            columns: [
                {
                    title: "用户手机",
                    dataIndex: "phoneNo",
                    // width: 200,
                    key: "2",
                },
                {
                    title: "套餐类型",
                    dataIndex: "packageType",
                    // width: 200,
                    key: "3",
                },
                {
                    title: "消费金额",
                    dataIndex: "amount",
                    // width: 200,
                    key: "4",
                },
                {
                    title: "成交id(站点id、小程序id等)",
                    dataIndex: "bizId",
                    // width: 200,
                    key: "5",
                },
                {
                    title: "成交时间",
                    dataIndex: "createTime",
                    // width: 200,
                    key: "8",
                },
            ],
            data: [
            ],
        }
    }

    packageTypeMap = {
        "SITE_ADVANCED_YEAR": "站点高级版包年",
        "SITE_EXCLUSIVE_YEAR": "站点尊享版包年",
        "SITE_EXCLUSIVE_LIFETIME": "站点钻石版",
        "VOTE_ADVANCED_YEAR": "投票高级版包年",
        "VOTE_ADVANCED_LIFETIME": "投票钻石版",
        "VOTE_ADVANCED_MONTH": "投票高级版包月",
        "VOTE_DIAMOND_ONE_YEAR": "投票钻石版包年",
        "VOTE_PLATINUM_ONE_YEAR": "投票白金版包年",
        "VOTE_PLATINUM_THREE_MONTH": "投票白金版三个月",
        "VOTE_PLATINUM_ONE_MONTH": "投票白金版包月",
        "APP_ADVANCED_YEAR": "小程序高级版包年",
        "APP_ADVANCED_LIFETIME": "小程序钻石版",
        "SITE_EXCLUSIVE_AND_APP": "站点小程序联合套餐",
        "IDK_PROFESSIONAL_YEAR": "快客多专业版包年",
        "KM_API_BASIC_YEAR": "快码短链API基础版包年套餐",
        "KM_API_ADVANCED_YEAR": "快码短链API进阶版包年套餐",
        "KM_API_EXCLUSIVE_YEAR": "快码短链API高级版包年套餐",
        "KM_SHORT_LINK_ADVANCED_YEAR": "快码短链进阶版包年套餐",
        "KM_SHORT_LINK_EXCLUSIVE_YEAR": "快码短链高级版包年套餐",
    };

    onPageChange = page => {
        this.setState(
            {
                current: page
            },
            () => {
                this.setState(
                    {
                        offset: (this.state.current - 1) * this.state.pageSize
                    },
                    () => {
                        this.renderData();
                    }
                );
            }
        );
    };

    renderData = () => {
        this.setState(
            {
                loading: true
            }
        );
        getConsumeRecord(this.state.offset, this.state.pageSize)
            .then(data => {
                console.log(data);
                if (data.consumes) {
                    this.setState(
                        {
                            loading: false,
                            total: data.total,
                            data: data.consumes.map( (item, index) => {
                                return {
                                    "key": index,
                                    "phoneNo": item.phoneNo,
                                    "packageType": this.packageTypeMap[item.packageType],
                                    "amount": item.amount / 100 + "元",
                                    "bizId": item.siteId || item.appId || item.shopId,
                                    "createTime": timestamp2DateStr(item.createTime),
                                }
                            }),
                        },
                    );
                }
                }
            );
    };

    componentDidMount() {
        this.renderData();
    }

    render() {
        return (
            <React.Fragment>
                <div className="consume-record">
                    <div className="info">客户消费记录</div>
                    <Table bordered={true}
                           pagination={
                               {
                                   current: this.state.current,
                                   total: this.state.total,
                                   pageSize: this.state.pageSize,
                                   onChange: this.onPageChange,
                               }
                           }
                           loading={this.state.loading}
                           columns={this.state.columns}
                           dataSource={this.state.data} />
                </div>
            </React.Fragment>
        );
    }
}

export default CustomerList;